module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-wrap"
  }, [_c('div', {
    staticClass: "file-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v("\n      " + _vm._s(_vm.file.basename) + " (" + _vm._s(_vm.fileSize) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "file-btns"
  }, [(_vm.file.url) ? _c('span', {
    staticClass: "file-btn file-btn__url",
    on: {
      "click": function($event) {
        _vm.urlShown = !_vm.urlShown
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "deleteBtn",
    staticClass: "file-btn file-btn__delete",
    on: {
      "click": _vm.deleteFile
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.file.url) ? _c('div', {
    staticClass: "file-link-tooltip",
    class: {
      opened: _vm.urlShown
    }
  }, [_vm._v("\n        " + _vm._s(_vm.file.url) + "\n        "), _c('div', {
    staticClass: "file-link-tooltip__close-wrap"
  }, [_c('button', {
    staticClass: "file-btn file-link-tooltip__close",
    on: {
      "click": function($event) {
        _vm.urlShown = !_vm.urlShown
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-type"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f2efc76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/publicFiles/File.vue
// module id = 921
// module chunks = 0